import { createDarkTheme, type Theme } from '@fluentui/react-components';
import { generateBrandRamp } from './brandRamp';

/** Phosphor-Grün-Rampe für den Pip-Boy-Modus (Fallout-CRT-Look). */
const pipBrand = generateBrandRamp('#36ff84');

export const PIP_FONT = "'Share Tech Mono', 'Consolas', 'Courier New', monospace";

/**
 * Fallout-Pip-Boy-Theme: dunkelgrünes CRT-Terminal. Überschreibt die zentralen
 * Fluent-Neutral-/Brand-Tokens auf Schwarz-Grün; den CRT-Effekt (Scanlines, Glow,
 * Vignette) liefert zusätzlich die globale CSS unter <html data-pip="on">.
 */
export function createPipTheme(): Theme {
  const base = createDarkTheme(pipBrand);
  return {
    ...base,

    // Flächen — Schwarz mit Grünstich
    colorNeutralBackground1: '#03160b',
    colorNeutralBackground1Hover: '#062310',
    colorNeutralBackground1Pressed: '#020f07',
    colorNeutralBackground1Selected: '#072a14',
    colorNeutralBackground2: '#051d0e',
    colorNeutralBackground3: '#072a14',
    colorNeutralBackground4: '#020f07',
    colorNeutralBackground5: '#010a05',
    colorNeutralBackground6: '#0a3318',
    colorNeutralBackgroundInverted: '#36ff84',
    colorNeutralBackgroundStatic: '#072a14',

    colorSubtleBackground: 'transparent',
    colorSubtleBackgroundHover: 'rgba(54,255,132,0.10)',
    colorSubtleBackgroundPressed: 'rgba(54,255,132,0.18)',
    colorSubtleBackgroundSelected: 'rgba(54,255,132,0.14)',

    // Text — Phosphor-Grün
    colorNeutralForeground1: '#73ffa6',
    colorNeutralForeground2: '#57ef8f',
    colorNeutralForeground2Hover: '#73ffa6',
    colorNeutralForeground3: '#41cf76',
    colorNeutralForeground4: '#2f9f59',
    colorNeutralForegroundDisabled: '#1e6b3e',
    colorNeutralForegroundInverted: '#02160a',

    // Linien
    colorNeutralStroke1: '#1c7a44',
    colorNeutralStroke2: '#125230',
    colorNeutralStroke3: '#0c3a22',
    colorNeutralStrokeAccessible: '#36ff84',

    // Brand (Akzente, Header, Buttons)
    colorBrandBackground: '#0c4a24',
    colorBrandBackgroundHover: '#0f5c2c',
    colorBrandBackgroundPressed: '#083818',
    colorBrandForeground1: '#8effb6',
    colorBrandForeground2: '#a6ffca',
    colorCompoundBrandForeground1: '#8effb6',
    colorCompoundBrandForeground1Hover: '#a6ffca',
    colorCompoundBrandStroke: '#36ff84',
    colorNeutralForegroundOnBrand: '#d7ffe6',

    fontFamilyBase: PIP_FONT,
    fontFamilyMonospace: PIP_FONT,
    fontFamilyNumeric: PIP_FONT,
  };
}
